import { useLocale } from "../i18n/useLocale.js";

export function ZaagplanEmptyState({ onLoadDemo }) {
  const { display } = useLocale();

  return (
    <div className="empty-visual">
      <strong>{display.t("web.empty.title")}</strong>
      <p className="empty-visual-copy">{display.t("web.empty.copy")}</p>
      <ul className="empty-visual-features">
        <li>{display.t("web.empty.featureKerf")}</li>
        <li>{display.t("web.empty.featurePdf")}</li>
      </ul>
      <button type="button" className="primary-button demo-load-button" onClick={onLoadDemo}>
        {display.t("web.actions.loadDemo")}
      </button>
      <p className="empty-visual-hint">{display.t("web.empty.hint")}</p>
    </div>
  );
}
